<template>
  <div>This is Dm</div>
</template>
<script type="text/javascript">
export default {
  name: 'Dm'
}

</script>



// WEBPACK FOOTER //
// src/Dm/containers/Dm.vue